class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      // Ignorar eventos de cambio de los selects de recomendaciones
      if (event.target && event.target.classList && event.target.classList.contains('recommended-variant-select')) {
        return;
      }
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0 && !Number.isNaN(inputValue % parseInt(event.target.step))) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach(form => {
    form.addEventListener('submit', async function(event) {
      event.preventDefault();

      const formData = new FormData(this);
      const submitButton = this.querySelector('[type="submit"]');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: cartData
          });
        } else {
          throw new Error('Error adding to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Error adding product to cart');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.originalText || 'Add to Cart';
        }
      }
    });

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton && !submitButton.dataset.originalText) {
      submitButton.dataset.originalText = submitButton.textContent;
    }
  });
});

// Variable global para rastrear si ya se agregó el event listener delegado
let recommendationsListenerAdded = false;

// Initialize cart recommendations on load
function initializeCartRecommendations() {
  const items = document.querySelectorAll('.recommended-product-item');
  console.log('🔄 Initializing recommendations, found items:', items.length);
  
  // Agregar event delegation UNA SOLA VEZ para todos los selects
  if (!recommendationsListenerAdded) {
    document.body.addEventListener('change', function(e) {
      if (e.target && e.target.classList.contains('recommended-variant-select')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        console.log('🔥 CHANGE EVENT FIRED via delegation!');
        
        const select = e.target;
        const selectedOption = select.options[select.selectedIndex];
        
        if (!selectedOption) {
          console.log('❌ No selected option found');
          return;
        }
        
        const variantId = selectedOption.value;
        const variantTitle = selectedOption.dataset.variantTitle || selectedOption.textContent.trim();
        const price = selectedOption.dataset.price;
        
        console.log('✅ Variant changed:', { variantId, variantTitle, price });
        
        // Buscar elementos dentro del product item
        const productItem = select.closest('.recommended-product-item');
        if (!productItem) return;
        
        const currentAddButton = productItem.querySelector('.recommended-add-btn');
        const currentPriceElement = productItem.querySelector('.recommended-product-price');
        const currentVariantTitleElement = productItem.querySelector('.recommended-variant-title');
        
        // Actualizar button
        if (currentAddButton && variantId) {
          currentAddButton.dataset.productId = variantId;
          console.log('✅ Button updated');
        }
        
        // Actualizar precio
        if (currentPriceElement && price) {
          const priceInDollars = (parseInt(price) / 100).toFixed(2);
          currentPriceElement.textContent = '$' + priceInDollars;
          console.log('✅ Price updated to:', currentPriceElement.textContent);
        }
        
        // Actualizar título
        if (currentVariantTitleElement && variantTitle) {
          currentVariantTitleElement.textContent = variantTitle;
          console.log('✅ Title updated to:', variantTitle);
        }
      }
    }, true); // Capture phase
    
    recommendationsListenerAdded = true;
    console.log('✓ Event delegation listener added');
  }
  
  items.forEach((item, index) => {
    const select = item.querySelector('.recommended-variant-select');
    const addButton = item.querySelector('.recommended-add-btn');
    const priceElement = item.querySelector('.recommended-product-price');
    const variantTitleElement = item.querySelector('.recommended-variant-title');
    
    if (!select || !addButton) return;
    
    // FORZAR texto en todas las opciones del select SOLO si están vacías
    Array.from(select.options).forEach((option, optIdx) => {
      const currentText = option.textContent ? option.textContent.trim() : '';
      const title = option.dataset.variantTitle || option.getAttribute('data-variant-title');
      
      if (title && currentText === '') {
        option.textContent = title;
        option.innerHTML = title;
      }
    });
    
    // SINCRONIZAR título y precio con la opción ACTUALMENTE seleccionada
    const currentOption = select.options[select.selectedIndex];
    if (currentOption) {
      const variantId = currentOption.value;
      const variantTitle = currentOption.dataset.variantTitle || currentOption.textContent.trim();
      const price = currentOption.dataset.price;
      
      // Actualizar button
      if (addButton && variantId) {
        addButton.dataset.productId = variantId;
      }
      
      // Actualizar título
      if (variantTitleElement && variantTitle) {
        variantTitleElement.textContent = variantTitle;
        variantTitleElement.innerHTML = variantTitle;
      }
      
      // Actualizar precio
      if (priceElement && price) {
        const priceInDollars = (parseInt(price) / 100).toFixed(2);
        priceElement.textContent = '$' + priceInDollars;
      }
      
      console.log(`✓ Item ${index} synchronized with variant: ${variantTitle}`);
    }
  });
}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initializeCartRecommendations();
  setTimeout(initializeCartRecommendations, 100);
  setTimeout(initializeCartRecommendations, 300);
  setTimeout(initializeCartRecommendations, 500);
  setTimeout(initializeCartRecommendations, 1000);
  
  // Suscribirse a eventos de actualización del carrito después de que todo cargue
  setTimeout(() => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        console.log('🔄 Cart updated via event, reinitializing recommendations');
        
        // REMOVER completamente las banderas de inicialización para forzar reinicio
        document.querySelectorAll('.recommended-variant-select').forEach(select => {
          delete select.dataset.initialized;
        });
        
        setTimeout(initializeCartRecommendations, 100);
        setTimeout(initializeCartRecommendations, 300);
        setTimeout(initializeCartRecommendations, 500);
        setTimeout(initializeCartRecommendations, 800);
      });
      console.log('✓ Subscribed to cart update events');
    }
  }, 1000);
});

// También ejecutar cuando el documento esté completamente cargado
window.addEventListener('load', () => {
  setTimeout(initializeCartRecommendations, 100);
  setTimeout(initializeCartRecommendations, 500);
});

// Run when cart recommendations are added to DOM
const observeCartRecommendations = new MutationObserver((mutations) => {
  let shouldInit = false;
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      // Verificar si se agregaron elementos con la clase de recomendaciones
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          if (node.classList && (node.classList.contains('recommended-product-item') || 
              node.classList.contains('recommended-products-section') ||
              node.querySelector && node.querySelector('.recommended-product-item'))) {
            shouldInit = true;
          }
        }
      });
    }
  }
  
  if (shouldInit) {
    console.log('🔄 MutationObserver detected changes, reinitializing');
    
    // REMOVER completamente las banderas de inicialización
    document.querySelectorAll('.recommended-variant-select').forEach(select => {
      delete select.dataset.initialized;
    });
    
    // Ejecutar múltiples veces para asegurar que funcione
    setTimeout(initializeCartRecommendations, 50);
    setTimeout(initializeCartRecommendations, 150);
    setTimeout(initializeCartRecommendations, 300);
    setTimeout(initializeCartRecommendations, 500);
  }
});

// Observe cart drawer for new recommendations
const setupObserver = () => {
  const cartDrawer = document.querySelector('cart-drawer-items') || 
                     document.querySelector('.cart-drawer__contents') ||
                     document.querySelector('#CartDrawer-CartItems') ||
                     document.querySelector('cart-drawer') ||
                     document.body;
  
  if (cartDrawer) {
    observeCartRecommendations.observe(cartDrawer, { childList: true, subtree: true });
    console.log('✓ Observer attached to:', cartDrawer.tagName || 'cart element');
  } else {
    // Retry if not found
    setTimeout(setupObserver, 500);
  }
};

setupObserver();

document.addEventListener('click', async function (e) {
    if (!e.target.classList.contains('recommended-add-btn')) return;

    e.preventDefault();
    const button = e.target;
    const productItem = button.closest('.recommended-product-item');
    const select = productItem.querySelector('.recommended-variant-select');
    
    // Obtener el variant ID directamente del select seleccionado
    let variantId = button.dataset.productId;
    
    // Si hay un select, usar su valor actual
    if (select) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) {
        variantId = selectedOption.value;
        console.log('🔍 Select found - using selected value:', variantId);
      }
    }
    
    console.log('🛒 Adding to cart - Button data-product-id:', button.dataset.productId);
    console.log('🛒 Adding to cart - Final Variant ID to add:', variantId);

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        if (response.ok) {
            const cartData = await fetch('/cart.js').then(r => r.json());

            // Publish an event using the same system as your existing code
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'recommendations',
                    cartData: cartData,
                    variantId: variantId
                });
            }
            // Remove the added product
            productItem.remove();
            
            // If there are no products left, hide the entire section.
            const remainingItems = document.querySelectorAll('.recommended-product-item');
            if (remainingItems.length === 0) {
                const section = document.getElementById('cart-recommendations');
                if (section) section.style.display = 'none';
            }

        } else {
            throw new Error('Failed to add product');
        }
    } catch (error) {
        console.error('Error:', error);
        button.disabled = false;
        button.textContent = 'ADD';
    }
});

// Reload recommendations when the cart is updated from other sources
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'recommendations') return;

        // Reload the cart-drawer section containing the recommendations
        setTimeout(() => {
            fetch(`${window.location.pathname}?section_id=cart-drawer`)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newRecommendations = doc.getElementById('cart-recommendations');
                    const currentRecommendations = document.getElementById('cart-recommendations');

                    if (newRecommendations && currentRecommendations) {
                        currentRecommendations.replaceWith(newRecommendations);
                    } else if (newRecommendations && !currentRecommendations) {
                        // Add recommendations if they did not exist before
                        const cartDrawer = document.querySelector('cart-drawer-items') || document.querySelector('.cart-drawer__contents');
                        if (cartDrawer) {
                            cartDrawer.appendChild(newRecommendations);
                        }
                    } else if (!newRecommendations && currentRecommendations) {
                        // Remove recommendations if products are no longer available
                        currentRecommendations.remove();
                    }
                })
                .catch(console.error);
        }, 300);
    });
}